import React from 'react';
import Loading from '@shared/components/loading/Loading';
import { MemberBox, WhiteBox, Span } from './leader-board-member.styles';
import { getIconRankBox, getImageRankBox } from './leader-board-member.utils';

const defaultProps = {
    loading: false,
    isDesktop: false,
};

interface LeaderBoardMemberProps {
    member: {
        name: string;
        quantity: number;
    }
    rank: number;
    loading: boolean;
    isDesktop?: boolean;
}

export const LeaderBoardMember = ({
    member, rank, loading, isDesktop,
}: LeaderBoardMemberProps) => (
    <MemberBox>
        {isDesktop ? (
            getIconRankBox(rank)
        ) : (
            <WhiteBox src={getImageRankBox(rank)} alt={rank} />
        ) }
        {loading ? (
            <Loading
                height={20}
                spinnerSize={20}
            />
        ) : <Span isDesktop={isDesktop}>{member.name}: {member.quantity}</Span>}
    </MemberBox>
);

LeaderBoardMember.defaultProps = defaultProps;
